// extracted by mini-css-extract-plugin
module.exports = {"body":"SwitchPages_body__1HXoZ"};